<template>
  <div class="wrapper">
    <a-pagination :total="total"
                  :show-total="total => `共${total}条`"
                  :page-size="size"
                  :current="currentPage"
                  :show-size-changer="isChangeSize"
                  :page-size-options="pageSizeOptions"
                  show-quick-jumper
                  @change="changePage"
                  @showSizeChange="onShowSizeChange" />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: false,
      default: 10
    },
    currentPage: {
      type: Number,
      required: false,
      default: 1
    },
    isChangeSize: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    pageSize: {
      handler(val){
        this.size = val
      },
      deep: true,
      immediate: true
    },
  },
  data(){
    return {
      pageSizeOptions: ['10', '30', '50', '100', '200'],
      size: 10
    }
  },
  methods: {
    changePage (page) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
      this.$emit('change', page)
    },
    onShowSizeChange(current,number){
      this.$emit('sizeChange',number);
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 10px;
  background: #ffffff;
  display: flex;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/common/pagination/Pagination.vue